<template>
	<div id="season-form">
    <!-- begin breadcrumb -->
		<ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{path: '/'}">Home</router-link>
      </li>
      <li>Duel</li>
      <li>
        <router-link :to="{path: '/season'}">List Season</router-link>
      </li>
      <li class="active">{{ !$route.query.id ? 'Buat' : 'Update' }} Season</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">{{ !$route.query.id ? 'Buat' : 'Update' }} Season</h1>
    <!-- end page-header -->
		<div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">{{ !$route.query.id ? 'Buat' : 'Update' }} Season</h4>
          </div>
          <div class="panel-body">
						<div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" :key="key">{{message}}</li>
              </ul>
            </div>

						<!-- begin form -->
            <form>
              <div class="form-horizontal form-bordered">
								<div class="form-group">
									<label class="col-md-2 control-label">Nama Season <span style="color: red">*</span></label>
									<div class="col-md-8 col-xs-12">
										<input type="text" class="form-control" v-model="data.name">
									</div>
								</div>

								<div class="form-group">
									<label class="col-md-2 control-label">Deskripsi <span style="color: red">*</span></label>
									<div class="col-md-8 col-xs-12">
										<ckeditor :editor="editor" v-model="data.description" :config="editorConfig"></ckeditor>
										<br />
										<span v-if="data.description"><i>({{characterCounter(data.description)}} karakter)</i></span>
									</div>
								</div>

								<div class="form-group">
										<label class="col-md-2 control-label">Gambar</label>
										<div class="col-md-8 col-xs-12">
											<div class="row">
												<div class="col-md-4" v-if="data.picture">
													<img class="img-fluid" :src="data.picture" />
												</div>
												<div class="col-md-8">
													<file-upload context="season" v-on:uploaded="data.picture = $event"></file-upload>
												</div>
											</div>
										</div>
									</div>

								<div class="form-group">
									<label class="col-md-2 control-label">Mulai Season <span style="color: red">*</span></label>
									<div class="col-md-8 col-xs-12">
										<div class="input-group">
											<input id="startDate" type="text" v-model="data.started_at" class="form-control datepicker" placeholder="Tanggal Mulai" name="started_at" />
											<span class="input-group-btn">
												<button class="btn btn-success" type="button">
													<i class="fa fa-calendar"></i>
												</button>
											</span>
										</div>
									</div>
								</div>

								<div class="form-group">
									<label class="col-md-2 control-label">
										Akhir Season <span style="color: red">*</span><br />(Berakhir pada jam 23:59)
									</label>
									<div class="col-md-8 col-xs-12">
										<div class="input-group">
											<input id="endDate" type="text" v-model="data.ended_at" class="form-control datepicker" placeholder="Tanggal Selesai" name="ended_at" />
											<span class="input-group-btn">
												<button class="btn btn-success" type="button">
													<i class="fa fa-calendar"></i>
												</button>
											</span>
										</div>
									</div>
								</div>
              </div>
            </form>
						<hr />
						<div class="pull-right">
							<button v-if="!$route.query.id" type="button" class="btn btn-success pull-right" @click="saveData()">Simpan</button>
							<button v-else type="button" class="btn btn-success pull-right" @click="editData()">Update</button>
            </div>
					</div>
				</div>
			</div>
		</div>
		<app-spinner v-if="isLoading"></app-spinner>
	</div>
</template>

<script>
import Moment from 'moment'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import DuelService from '@/services/duel.js'
import Spinner from '@/components/plugins/Spinner'
import FileUpload from '@/components/plugins/FileUpload'

export default {
	name: 'season-form',
	components: {
		'app-spinner': Spinner,
		'file-upload': FileUpload,
	},
	data: function () {
		return {
			queryId: null,
			errors: [],
			isLoading: false,
			selectedPicture: null,
			data: {
				name: null,
				description: null,
				picture: null,
				started_at: null,
				ended_at: null,
			},
			editor: ClassicEditor,
			editorConfig: {
				toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'outdent', 'indent'],
			}
		}
	},
	mounted: function () {
		this.getDatePickerPlugin()

		if (this.$route.query.id) {
			this.queryId = this.$route.query.id
			this.fetchData()
		}
	},
	methods: {
		fetchData: function () {
			var context = this
			var queryId = this.queryId
			this.isLoading = true

			DuelService.getSeasonDetail(queryId, function (result) {
				context.isLoading = false

				if (result.success) {
					context.data.name = result.data.name
					context.data.description = result.data.description
					context.data.picture = result.data.picture
					context.data.started_at = Moment(result.data.started_at).format("D MMMM YYYY")
					context.data.ended_at = Moment(result.data.ended_at).format("D MMMM YYYY")
				} else {
					alert('Terjadi kesalahan : ' + result.message)
				}
			})
		},
		saveData: function () {
			var context = this
			var data = this.data
			this.isLoading = true

			data.started_at = Moment(data.started_at).format('YYYY-MM-DD')
			data.ended_at = Moment(data.ended_at).format('YYYY-MM-DD')

			if (this.validateForm()) {
				DuelService.addSeason(data, function (result) {
					context.isLoading = false
					if (result.success) context.$router.push({ path: '/season' })
					else {
						if (result.data) alert("Waktu Mulai Season dan Akhir Season tidak diizinkan")
						else alert("Terjadi Kesalahan : " + result.message)
					}
				})
			} else {
				this.isLoading = false
				$(window).scrollTop(0)
			}
		},
		editData: function () {
			var context = this
			var id = this.queryId
			var data = this.data
			this.isLoading = true

			data.started_at = Moment(data.started_at).format('YYYY-MM-DD')
			data.ended_at = Moment(data.ended_at).format('YYYY-MM-DD')

			if (this.validateForm()) {
				DuelService.updateSeason(id, data, function (result) {
					if (result.success) context.$router.push({ path: '/season' })
					else {
						if (result.data) alert("Waktu Mulai Season dan Akhir Season tidak diizinkan")
						else alert("Terjadi Kesalahan : " + result.message)
						context.isLoading = false
					}
				})
			} else {
				this.isLoading = false
				$(window).scrollTop(0)
			}
		},
		validateForm: function () {
			this.errors = []
			if (!this.data.name) this.errors.push('Nama Season wajib diisi')
			if (!this.data.description) this.errors.push('Deskripsi wajib diisi')
			if (this.data.description) {
				if (this.characterCounter(this.data.description) > 1000) {
					this.errors.push('Deskripsi tidak boleh lebih dari 1000 karakter')
				}
			}
			if (!this.data.started_at) this.errors.push('Tanggal Mulai wajib diisi')
			if (!this.data.ended_at) this.errors.push('Tanggal Selesai wajib diisi')
			return this.errors.length == 0
		},
		characterCounter: function (text) {
			text = text.replace(/<[^>]*>/g, '')
			text = text.replace(/\&nbsp;/g, ' ')
			return text.length
		},
		getDatePickerPlugin: function () {
			var context = this

			DatepickerPlugin.init("#startDate", function (value) {
				context.data.started_at = Moment(value, "DD/MM/YYYY").format("D MMMM YYYY")
			})

			DatepickerPlugin.init("#endDate", function (value) {
				context.data.ended_at = Moment(value, "DD/MM/YYYY").format("D MMMM YYYY")
			})
		},
	}
}
</script>

<style>
.ck-content {
  min-height: 120px;
}
</style>


// WEBPACK FOOTER //
// SeasonForm.vue?016752ff